export enum MeasureType {
    Distance = "distance",
    Area = "area",
    Peilelinjal = "peilelinjal",
    Angle = "vinkelmåler",
}

export enum Unit {
    Meter = "meter",
    Nautiskemil = "nautiske mil",
}
